export default __webpack_public_path__ + "static/media/home.78de59dc.svg";